import { useId } from "react";

// Réplica de StarMark (star-circle-app.jsx:13-45), recortada a lo que usa
// admin.jsx:3801 (ring + stroke, sin glow). Primitiva compartida.
export function StarMark({
  size = 64,
  ring = true,
  stroke = 1.2,
}: {
  size?: number;
  ring?: boolean;
  stroke?: number;
}) {
  const rawId = useId();
  const id = "m" + rawId.replace(/:/g, "");

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      style={{ overflow: "visible" }}
    >
      <defs>
        <linearGradient id={"scSilver" + id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F4F5F6" />
          <stop offset="0.4" stopColor="#BFC1C6" />
          <stop offset="0.62" stopColor="#EDEEF0" />
          <stop offset="1" stopColor="#9A9DA3" />
        </linearGradient>
      </defs>
      <g>
        {ring ? (
          <circle
            cx="50"
            cy="50"
            r="44"
            fill="none"
            stroke={`url(#scSilver${id})`}
            strokeWidth={stroke}
            strokeOpacity="0.85"
          />
        ) : null}
        <path
          d="M50 16 C52 38 62 48 84 50 C62 52 52 62 50 84 C48 62 38 52 16 50 C38 48 48 38 50 16 Z"
          fill={`url(#scSilver${id})`}
        />
      </g>
    </svg>
  );
}
